"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EnvironmentsModal = void 0;
var _react = _interopRequireWildcard(require("react"));
var _hooks = require("../../../../hooks");
var _Course = require("../Course.labels");
var _Modal = require("../../../../Layout/Modal");
var _Button = require("../../../../UI/Button");
var _List = require("../../../../Data/List");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const EnvironmentsModal = props => {
  const getLabel = (0, _hooks.useLabels)({
    labels: _Course.labels
  });
  const {
    selectedEnvironmentId,
    environments,
    url,
    title,
    onConfirm,
    onClose
  } = props;
  const [environmentSelected, setEnvironmentSelected] = (0, _react.useState)();
  (0, _react.useEffect)(() => {
    setEnvironmentSelected(selectedEnvironmentId ?? environments[0].id);
  }, [environments, selectedEnvironmentId]);
  const handleConfirmClick = event => {
    window.open(`${url}?audience=${environmentSelected}`);
    if (onConfirm) {
      onConfirm(event, environmentSelected);
    }
    if (onClose) {
      onClose();
    }
  };
  const handleListItemClick = (0, _react.useCallback)(environmentId => {
    setEnvironmentSelected(environmentId);
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Modal.Modal, {
    isOpen: true,
    onClose: onClose,
    isStandAlone: true,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Header, {
      title: getLabel('choose_audience'),
      subTitle: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Content, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_List.List, {
        children: environments.map(environment => /*#__PURE__*/(0, _jsxRuntime.jsx)(_List.List.Item, {
          id: environment.id,
          color: "primary",
          isSelected: environmentSelected === environment.id,
          onClick: handleListItemClick,
          children: environment.name
        }, environment.id))
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Footer, {
      justifyContent: "center",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Footer.Section, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
          id: "ccEnvironmentModalButton",
          view: "outlined",
          color: "primary",
          onClick: handleConfirmClick,
          children: getLabel('confirm')
        })
      })
    })]
  });
};
exports.EnvironmentsModal = EnvironmentsModal;